import Loader from "@components/global/Loader/Loader";
import cn from "classnames";
import React, { useRef } from "react";
import styles from "./Icon.module.scss";
import { IconPropsI } from "./Icon.props";

export default function Icon({
  src,
  className,
  noHover: disHover,
  loading,
  onClick,
  ...props
}: IconPropsI) {
  const ref = useRef<HTMLDivElement>(null);
  const onClickIcon = (e: React.MouseEvent<HTMLDivElement>) => {
    onClick && onClick(e);
    if (!disHover) {
      ref.current?.classList.add(styles.click);
      setTimeout(() => ref.current?.classList.remove(styles.click), 50);
    }
  };
  return (
    <div
      className={cn(styles.icon, className, {
        [styles.hoverable]: !disHover,
        [styles.isLoader]: loading,
      })}
      ref={ref}
      onClick={onClickIcon}
      {...props}
    >
      {loading && <Loader size={15} />}
      {/*  eslint-disable-next-line jsx-a11y/alt-text */}
      {/* <object type='image/svg+xml' data={src} /> */}
      <img src={src} loading='lazy' alt='' />
    </div>
  );
}
